import {
  TextField,
  Grid,
  Checkbox,
  FormControlLabel,
} from '@mui/material'

function GreenbookProgressFields({
  startPage,
  endPage,
  assignmentCompleted,
  notes,
  onStartPageChange,
  onEndPageChange,
  onAssignmentCompletedChange,
  onNotesChange,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Starting Page"
            type="number"
            value={startPage}
            onChange={onStartPageChange}
            InputProps={{ inputProps: { min: 1 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Ending Page"
            type="number"
            value={endPage}
            onChange={onEndPageChange}
            InputProps={{ inputProps: { min: 1 } }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Notes"
            multiline
            rows={4}
            value={notes}
            onChange={onNotesChange}
            placeholder="Add any notes about green book assignment here..."
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={assignmentCompleted}
                onChange={onAssignmentCompletedChange}
              />
            }
            label="Assignment Completed"
          />
        </Grid>
      </Grid>
    </>
  )
}

export default GreenbookProgressFields
